/** @format */
import type { BaseResponse } from '@/utils';
import { request, requestRoot } from '@/utils';
import { getEnvUrlByUrl } from '@/utils/power';
/**
 * @description 登录
 * @param {LoginParams} data
 * @returns
 */
export function login(authType = 'native', data) {
	let url = '/auth/login';
	if (authType === 'ldap') {
		url = '/auth/ldapLogin';
	}
	return request(
		{
			url,
			headers: {
				isToken: false,
			},
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 退出方法
export function logout() {
	return request({
		url: '/auth/logout',
		method: 'delete',
	});
}

export async function getFrontEndConfig(params?: any) {
	try {
		const res: any = await request(
			{
				url: '/system/oems',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: true,
			},
		);
		const { oemJson } = res;
		const oemJsonObj = JSON.parse(oemJson || '{}');
		const sysConfigVos = [
			{
				id: '03',
				name: '登录页配置',
				code: 'login',
				itemNum: '1',
				itemName: '浏览器展示logo',
				itemCode: 'logo',
				itemType: 'image',
				itemValue: oemJsonObj.logo || '/power-base/frontend/logo.png',
				configType: 'frontEnd',
			},
			{
				id: '04',
				name: '登录页配置',
				code: 'login',
				itemNum: '2',
				itemName: '页面Title',
				itemCode: 'title',
				itemType: 'input',
				itemValue: oemJsonObj.title || '一体化应用平台',
				configType: 'frontEnd',
			},
			{
				id: '05',
				name: '登录页配置',
				code: 'login',
				itemNum: '3',
				itemName: '备案信息',
				itemCode: 'copyright',
				itemType: 'input',
				itemOptions: null,
				itemValue: oemJsonObj.copyright || '',
				configType: 'frontEnd',
			},
			{
				id: '06',
				name: '登录页配置',
				code: 'login',
				itemNum: '4',
				itemName: '首页头部Logo',
				itemCode: 'headerLogo',
				itemType: 'image',
				itemOptions: null,
				itemValue: oemJsonObj.logo || '/power-base/frontend/logo.png',
				configType: 'frontEnd',
			},
			{
				id: '09',
				createBy: null,
				createTime: null,
				updateBy: '1',
				updateTime: '2023-06-08 09:14:59',
				deleted: null,
				serNum: '2',
				name: '登录页配置',
				code: 'login',
				itemNum: '7',
				itemName: '密码错误次数锁定账户',
				itemCode: 'loginFailTimesOfLockAccount',
				itemType: 'input',
				itemOptions: null,
				itemValue: '5',
				configType: 'frontEnd',
				fileId: null,
				fileName: null,
				filePath: null,
			},
			{
				id: '19',
				createBy: null,
				createTime: null,
				updateBy: '1',
				updateTime: '2023-06-08 09:14:59',
				deleted: null,
				serNum: '2',
				name: '登录页配置',
				code: 'login',
				itemNum: '8',
				itemName: '公司名称',
				itemCode: 'companyName',
				itemType: 'input',
				itemOptions: null,
				itemValue: '科技股份有限公司',
				configType: 'frontEnd',
				fileId: null,
				fileName: null,
				filePath: null,
			},
			{
				id: '20',
				name: '登录页配置',
				code: 'login',
				itemNum: '9',
				itemName: '登录背景图',
				itemCode: 'backgroundImage',
				itemType: 'image',
				itemOptions: null,
				itemValue: oemJsonObj.signinBackground || '/power-base/frontend/signinBackground.png',
				configType: 'frontEnd',
			},
		];

		const loginObj = {
			code: 'login',
			name: '登录页配置',
			sysConfigVos,
		};
		const resFrontEndConfig = [loginObj];

		return resFrontEndConfig;
	} catch (error) {
		// console.log('error', error);
		throw new Error('【power--runtime】获取网站配置出错。');
	}
}

/**
 * 获取用户是否已登录
 * @param params
 */
export async function getLoggedIn(params?: any) {
	try {
		if (window.location.href.indexOf('/auth/oauth2Login?code') > -1 || window.location.href.indexOf('?ticket=') > -1) {
			// 已登录
			//console.log('loggedIn', true);

			return true;
		}
		const loggedIn = await request(
			{
				url: '/auth/login/valid',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: true,
			},
		);
		//console.log('loggedIn', loggedIn);

		return loggedIn;
	} catch (error) {
		// console.log('error', error);
		throw new Error('【power--runtime】获取 用户是否登录 信息出错。');
	}
}

/**
 * 获取用户信息
 * @param params
 */
export async function getUserInfo(
	params = {
		_t: new Date().getTime(),
	},
) {
	try {
		const res: any = await request(
			{
				url: '/system/user/getInfo',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: false,
			},
		);
		res.user.account = res.user.userAccount;
		return res;
	} catch (error) {
		console.log('error', error);
		throw new Error('【power--runtime】获取用户信息出错。');
	}
}

/**
 * 获取获取子系统信息
 * @param params
 */
export async function getSubSystem(params?: any) {
	try {
		const { url, ...otherParams } = params;
		let realUrl = url;
		if (!realUrl) {
			realUrl = params.isMobile
				? '/power-api/power-factory/data-processing/list?designerId=system&appFlag=1'
				: '/power-api/power-factory/data-processing/list?designerId=system&appFlag=0';
		}
		realUrl = getEnvUrlByUrl(realUrl);
		return await requestRoot(
			{
				url: realUrl,
				method: 'get',
				params: {
					...otherParams,
				},
			},
			{
				isGetDataDirectly: true,
			},
		);
	} catch (error) {
		// console.log('error', error);
		throw new Error('【power--runtime】获取获取子系统信息出错。');
	}
}

/**
 * 获取当前系统菜单
 * @param params
 */
export async function getMenu(params?: any) {
	try {
		let { url = '/power-api/power-factory/data-processing/list/app', ...otherParams } = params;
		url = getEnvUrlByUrl(url);
		return await requestRoot(
			{
				url,
				method: 'get',
				params: {
					...otherParams,
					businessId: otherParams.systemId,
					designerId: 'menu',
				},
			},
			{
				isGetDataDirectly: true,
			},
		);
	} catch (error) {
		// console.log('error', error);
		throw new Error('【power--runtime】获取当前系统菜单出错。');
	}
}
export function fileUpload(file, alias) {
	const data = new FormData(); // 创建form对象
	data.append('file', file);
	data.append('folderAlias', alias);
	data.append('groupKey', '');
	return request<BaseResponse>({
		url: '/file/upload',
		method: 'post',
		timeout: 0,
		data,
	});
}
